module.exports = __webpack_public_path__ + "static/img/platformBenefits.c91cdc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/platformBenefits.png
// module id = spjR
// module chunks = 0